<template>
  <Button :loading="loading" loadingText="提交中..." type="danger" text="提交" :disabled="isDisabled" class="nextStep" :click="onSubmit" />
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { Toast } from 'vant';
import JSencrypt from '@/utils/rsa/jsencrypt';
import Button from './Button.vue';
import { buildXydAgreementLog, buildXydTypeList, flattenXydContracts } from '@/utils/xydNoTax';

export default {
  name: 'SubmitButton',
  data() {
    return {
      isDisabled: true,
      loading: false,
      orderId: '',
    };
  },
  props: ['params', 'errorMessage', 'allowClearHandler', 'form'],
  components: {
    Button,
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('commonForms', ['getModel']),
    ...mapMutations('commonForms', ['updateForm']),
    ...mapActions('publicPage', ['sendPicCode']),
    onSubmit() {
      const obj = this.form.getState();
      // eslint-disable-next-line no-underscore-dangle
      const contract = this.form._currentState.Contract;
      const contractList = contract ? contract.props.list : [];
      const submitContractList = flattenXydContracts(contractList);
      const params = {
        // 丢失corpId
        ...this.publicPage.submitInfoAll,
        productId: this.$route.query.productId,
        corpName: obj.corpName, // 无企业时为空
        taxNo: obj.taxNo, // 无企业时为空
        userType: obj.borrowerType, // 申请人类型，// 无企业时为空
        userName: obj.borrowerName, // 姓名
        identity: obj.borrowerIdentity, // 身份证
        phone: obj.borrowerPhone, // 手机号
        referrer: obj.referrer, // 邀请码
        typeList: buildXydTypeList(this.publicPage?.submitInfoAll?.productId || this.$route.query.productId, submitContractList), // 授权书
        ...buildXydAgreementLog({
          productId: this.publicPage?.submitInfoAll?.productId || this.$route.query.productId,
          formData: obj,
          submitInfo: this.publicPage.submitInfoAll,
          contractList: submitContractList,
        }),
      };

  
      this.nextStep(params);
    },

    async nextStep(data) {
      const encrypt = new JSencrypt();
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      const val = this.form.getState();
      // eslint-disable-next-line no-underscore-dangle
      const contract = this.form._currentState.Contract;
      const contractList = contract ? contract.props.list : [];
      const submitContractList = flattenXydContracts(contractList);
      const resproductId = await this.$api.PublicPage.getNewProductId({
        productId: this.publicPage?.submitInfoAll?.productId,
        taxNo: this.publicPage?.submitInfoAll?.taxNo,
      });
      // this.$route.query.productId = resproductId.data;
      const params = {
        ...this.publicPage.submitInfoAll,
        userType: this.publicPage.submitInfoAll.applyType,
        identity: this.publicPage.submitInfoAll.applyId,
        phone: this.publicPage.submitInfoAll.applyPhone,
        userName: this.publicPage.submitInfoAll.applyName,
        ...data,
        // 需要加密字段
        bankCard: encrypt.encrypt(this.publicPage.submitInfoAll.bankCard) || '',
        creditBankCard: encrypt.encrypt(this.publicPage.submitInfoAll.creditBankCard) || '',
        iceContactIdentity: encrypt.encrypt(this.publicPage.submitInfoAll.iceContactIdentity) || '',
        iceContactPhone: encrypt.encrypt(this.publicPage.submitInfoAll.iceContactPhone) || '',
        typeList: buildXydTypeList(resproductId.data, submitContractList, { excludeAuthorization: true }), // 授权书,
        productId: resproductId.data,
        foreignOrderId: this.$route.query.foreignOrderId,
        ...buildXydAgreementLog({
          productId: resproductId.data,
          formData: val,
          submitInfo: {
            ...this.publicPage.submitInfoAll,
            ...data,
          },
          contractList: submitContractList,
        }),
      };
      this.$api.PublicPage.saveOrderUnite(params).then((res) => {
        if (res.success) {
          localStorage.setItem('orderId', res.data.orderId);
          this.updateForm({
            orderId: res.data.orderId,
          });
          this.orderId = res.data.orderId;
          this.judgeModelData(this.getModel);
        } else if (res.returnCode === '30010') {
            this.sendPicCode();
          } else {
          this.$toast.clear();
          this.updateForm({
            Isloading: false,
          });
          this.$toast.fail({
            message: res.returnMessage,
            forbidClick: true,
          });
        }
      });
    },
    async judgeModelData(callback) {
      const res = await this.$api.PublicPage.isDataAcquisition({
        orderId: this.orderId,
        productId: this.publicPage?.submitInfoAll?.productId,
      });
      // 根据type false true 判断是否跑模型还是去数据采集
      if (res.data.type) {
        const { data, returnCode, returnMessage } = await this.$api.PublicPage.jumpCurrPage({
          orderId: this.orderId,
        });
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!data) {
          window.location.href = data;
        } else if (returnCode !== '200') {
          Toast(returnMessage);
        }
      } else {
        // 是否需要跳转选择核心企业
        const { success, data, returnMessage } = await this.$api.CommonForms.getCoreCorpPage({
          orderId: this.orderId,
        });
        if (success) {
          ['1', '2'].includes(data.type) ? window.location.href = data.url : callback(); // 调用跑模型接口
        } else {
          Toast(returnMessage);
        }
      }
    },
  },
  watch: {
    'form.passThrough': {
      handler() {
        this.isDisabled = this.form.passThrough;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped></style>
